(function () {
  function getSettings() {
    return window.MinimogSettings || {};
  }

  function getCartDrawer() {
    return document.querySelector('m-cart-drawer');
  }

  function shouldHandle(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    if (!form.querySelector('[name="id"]')) return false;

    var inLpzContext = form.closest(
      '[data-lpz-collection-list], .lpz-collection-shop, .lpz-product-recs, .lpz-recs-grid, .lpz-product-page, .products-section, .tabs-section'
    );
    if (!inLpzContext) return false;

    if (
      form.matches('.prod-form, .lpz-pc-form, .product-card-form') ||
      form.querySelector('.lpz-btn-atc, .add-btn, .add-to-cart')
    ) {
      return true;
    }

    return false;
  }

  function toggleLoading(form, isLoading) {
    var wrap = form.closest('product-form, .prod-card, .lpz-pc');
    if (!wrap) return;
    wrap.classList.toggle('adding', isLoading);
    var btn = form.querySelector('[type="submit"], [name="add"]');
    if (btn) btn.disabled = isLoading;
  }

  function ajaxAddToCart(form) {
    var settings = getSettings();
    var cart = getCartDrawer();
    var cartAddUrl =
      (settings.routes && settings.routes.cart_add_url) || '/cart/add.js';

    var config = {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    };

    var body = new FormData(form);

    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.append(
        'sections',
        cart
          .getSectionsToRender()
          .map(function (section) {
            return section.id;
          })
          .join(',')
      );
      body.append('sections_url', window.location.pathname);
    }

    config.body = body;
    toggleLoading(form, true);

    return fetch(cartAddUrl, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.status) {
          throw new Error(data.description || data.message || 'Could not add to cart');
        }

        if (settings.enable_cart_drawer && cart && typeof cart.renderContents === 'function') {
          cart.renderContents(data);
          if (
            window.MinimogTheme &&
            window.MinimogTheme.Notification &&
            window.MinimogStrings &&
            cart.cartDrawerItems
          ) {
            window.MinimogTheme.Notification.show({
              target: cart.cartDrawerItems,
              method: 'prepend',
              type: 'success',
              message: window.MinimogStrings.itemAdded,
              delay: 400,
            });
          }
        } else if (settings.routes && settings.routes.cart) {
          window.location = settings.routes.cart;
        }

        if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
          window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, data);
        }

        return data;
      })
      .finally(function () {
        toggleLoading(form, false);
      });
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!shouldHandle(form)) return;

      var productForm = form.closest('product-form');
      var settings = getSettings();

      if (productForm && settings.use_ajax_atc && productForm.form === form) {
        return;
      }

      event.preventDefault();
      ajaxAddToCart(form).catch(function (error) {
        if (window.MinimogTheme && window.MinimogTheme.Notification) {
          window.MinimogTheme.Notification.show({
            target: document.body,
            method: 'appendChild',
            type: 'warning',
            message: error.message || 'Could not add to cart',
            last: 3000,
          });
        }
      });
    },
    true
  );
})();
